import '@fontsource/montserrat/latin-200.css';
import '@fontsource/montserrat/latin-200-italic.css';
import '@fontsource/montserrat/latin-300.css';
import '@fontsource/montserrat/latin-300-italic.css';
import '@fontsource/montserrat/latin-400.css';
import '@fontsource/montserrat/latin-400-italic.css';
import '@fontsource/montserrat/latin-500.css';
import '@fontsource/montserrat/latin-500-italic.css';
import '@fontsource/montserrat/latin-600.css';
import '@fontsource/montserrat/latin-600-italic.css';
import '@fontsource/montserrat/latin-700.css';
import '@fontsource/montserrat/latin-700-italic.css';
import '@fontsource/montserrat/latin-800.css';
import '@fontsource/montserrat/latin-800-italic.css';
import '@fontsource/montserrat/latin-900.css';
import '@fontsource/montserrat/latin-900-italic.css';

import LaravelPermissions from 'laravel-permissions';
import Vue from 'vue';
import axios from './api';
import App from './App.vue';
import ValidationErrors from './components/ValidationErrors';
import router from './router';
import store from './store';
import Responsive from './mixins/ResponsiveHelpers.vue';
import Permissions from './mixins/PermissionsHelpers.vue';
import Templates from './mixins/TemplatesHelpers.vue';
import PermissionsFileSystem from './mixins/PermissionsFileSystem';
import VerifyDates from './mixins/VerifyDates';
import DeactivateLoading from './mixins/DeactivateLoading';
import VueTour from 'vue-tour';
import Chart from 'chart.js';


require('./../css/vue-tour.css');
//require('vue-tour/dist/vue-tour.css');

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.use(LaravelPermissions);
Vue.use(VueTour);
//Vue.use(Chart);
import moment from 'moment';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});
Vue.component('VErrors', ValidationErrors);
Vue.mixin(Responsive);
Vue.mixin(Permissions);
Vue.mixin(Templates);
Vue.mixin(PermissionsFileSystem);
Vue.mixin(VerifyDates);
Vue.mixin(DeactivateLoading);

store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    Chart,
    render: h => h(App),
  }).$mount('#app');
});
